<span [ngClass]="classes" class="se-sprite fa-{{ spriteName }}"> </span>
